module.exports = __webpack_public_path__ + "static/media/film-icon.ff65f869.png";